import * as Yup from "yup";

export const kursusKorrespondanceForm = (
  kursusId: string,
  kursusKorrespondanceId?: string,
): FormConfig<IKursusKorrespondanceForm> => {
  const req = `kursus/${kursusId}/korrespondancer/${kursusKorrespondanceId}`;
  return {
    title: "korrespondance",
    lockedValues: [
      {
        id: "kursusId",
        value: kursusId,
      },
      {
        id: "kursusKorrespondanceId",
        value: kursusKorrespondanceId,
      },
    ],
    validationSchema: Yup.object(),
    form: [
      {
        component: "datepicker",
        id: "opretDato",
        label: "Oprettet dato",
        initialValue: "",
      },
    ],
    get: req,
    getDocument: req + "/dokument",
    downloadLink: req + "/download",
    delete: () => {
      return {
        query: req,
      };
    },
  };
};

interface IKursusKorrespondanceForm {
  id: string;
  data: any | null;
  antalModtagere: number;
  opretDato: string;
  opretInit: string | null;
  retteDato: string | null;
  retteInit: string | null;
  kursusholdId: string;
}
